import axios from "axios";
import { accessDenied, apiError, apiStart, apiEnd } from "../actions/api";
import { getAuthToken } from "../authentication/authToken";
import { loginRequest } from "../authentication/authConfig";

const apiMiddleware = ({ dispatch }) => next => action => {
  next(action);

  if (action.type !== "API") return;

  const {
    url,
    method,
    data,
    onSuccess,    
    label,
    headers
  } = action.payload;
  const dataOrParams = ["GET"].includes(method) ? "params" : "data";

  let token = getAuthToken();
  // axios default configs
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL || "";
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.headers.common["Authorization"] = `Bearer ${token.idToken}`;
  axios.defaults.headers.common["GraphToken"] = `Bearer ${token.graphToken}`;
  //axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

  if (label) {
   // console.log({label});
    dispatch(apiStart(label));
  }

  axios
    .request({
      url,
      method,
      headers,
      [dataOrParams]: data
    })
    .then(({ data }) => {
      dispatch(onSuccess(data));
    })
    .catch(error => {
      dispatch(apiError(error));
      // dispatch(onFailure(error));

      if (
        error.response &&
        (error.response.status === 403 || error.response.status === 401)
      ) {
        dispatch(accessDenied(window.location.pathname));

        let instance = window.msalInstance;
        const userName = window.msalUserName;

        let redRequest = {
          scopes: loginRequest.scopes,
          loginHint: userName
        };
        console.log(
          `API error ${error.response.status}, Redirecting to login...`
        );
        return instance.acquireTokenRedirect(redRequest);
      }
    })
    .finally(() => {
      if (label) {
        dispatch(apiEnd(label));
      }
    });
};

export default apiMiddleware;
